class cartSubscriptionBtn extends HTMLElement {
  constructor() {
    super();
    this.cart = this.closest('cart-drawer') || this.closest('cart-items');
    this.data = JSON.parse(this.querySelector('[data-json]').innerText);
    this.actionBtn = this.querySelector('[data-subscription-btn-action]');
    this.actionBtn.addEventListener('click',event => this.itemAddRemoveAction())
  }
  itemAddRemoveAction(){
    this.cart.enableLoading(this.data.index);
    this.actionBtn.classList.add("loading","disabled");
    this.actionBtn.diabled = true;
    let removeItems = {},
        addItems = {};
    removeItems.updates = {};
    addItems.items = [];
    removeItems.updates[this.data.main_key] = 0;
    if(this.data.installationproductKey != "null"){
     removeItems.updates[this.data.installationproductKey] = 0;
      addItems.items.push({
        id:this.data.upcell_id,
        quantity:1,
        properties:this.data.installationproductProperties
      });
    }
    addItems.items.push({
      id:this.data.main_id,
      quantity:this.data.main_quantity,
      properties:this.data.main_properties,
      selling_plan:this.data.selling_id
    });

    addItems.sections = this.cart.getSectionsToRender().map((section) => section.section);
    addItems.sections_url = window.location.pathname;

    let body = JSON.stringify(removeItems);

    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      ...{
        body
      }
    }).then((response) => {
      return response.text();
    }).then(data => {
      this.cart.updateQuantity(this.data.index, null, null,null,addItems);
    });
    
  }
}
customElements.define('cart-subscription-btn', cartSubscriptionBtn);

class cartUpsellInstallation extends HTMLElement {
  constructor(){
    super();
    this.cart = this.closest('cart-drawer') || this.closest('cart-items');
    this.data = JSON.parse(this.querySelector('[data-json]').innerText);
    this.querySelector('.js-cart-upsell-checkbox').addEventListener('change',event => this.UpsellAction());
  }
  UpsellAction(){
    this.cart.enableLoading(this.data.index);
    let updateItem = {};
    updateItem.updates = {};
    updateItem.updates[this.data.key] = 0;
    let body = JSON.stringify(updateItem),
        uniqId = new Date().getTime();

    let formData = {};
    formData.items = [];
    formData.items.push({
      id:this.data.upcell_id,
      quantity: 1,
      properties:{
        _intallationproduct: true,
        _uniqId: uniqId
      }
    });
    let mainProperties = this.data.properties || {};
    mainProperties._haveInstallationProduct = "true";
    mainProperties._uniqId = uniqId;

    let mainProductData = {
      id:this.data.main_id,
      quantity: this.data.quantity,
      properties: mainProperties
    };
    if(this.data.selling_id != "null") mainProductData.selling_plan = this.data.selling_id;
    formData.items.push(mainProductData);

    formData.sections = this.cart.getSectionsToRender().map((section) => section.section);
    formData.sections_url = window.location.pathname;

    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      ...{
        body
      }
    }).then((response) => {
      return response.text();
    }).then(data => {
      this.cart.updateQuantity(this.data.index, null, null,null,formData);
    });
  }
}
customElements.define('cart-upsell-installation', cartUpsellInstallation);

class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0,"",this);
      var url = "https://www.guideprotection.com/protectit/core/clientjs/protection_master_higherdose.js";
      setTimeout(function() {
        $.getScript(url, function() {
          getDrawerProductUpdate();
        });
      }, 500); 
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    
    // Elements
    this.drawer = document.getElementById('cart-drawer');
    this.cartButton = document.querySelector('.js-open-cart');
    this.cartButton.addEventListener('click', this.handleCartClick.bind(this));
    this.closeIcon = document.getElementById('cart-drawer__close');
    this.closeIcon.addEventListener('click', this.close.bind(this));
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.pageOverlayElement = document.querySelector('.page-overlay');
    // Functionality
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));    

    // Extend - add listener for soft refresh called by ajax-side-cart-integration
    window.addEventListener('handleRefresh', this.handleRefresh.bind(this));
    // Extend - End Extend Code
    
    document.addEventListener('rebuy:smartcart.hide', (event) => {
      const smartcart = event.detail.smartcart;
      this.refreshCart()
    });
  }
  // handleRefresh(e)
  // creates the cart based on the cart that is passed in from event listener
  handleRefresh (e){
    this.refreshCart()
    window.setTimeout(function() {
		window.dispatchEvent(Extend.CustomEvent('refreshAjaxCart'))
    }, 500)
  }
  // Extend - End Extend Code
  
  open() {
    // Extend - Dispatch refreshAjaxCart to initializeCartOffers on open
    window.dispatchEvent(Extend.CustomEvent('refreshAjaxCart'))
    // Extend - End Code
    
    var url = "https://www.guideprotection.com/protectit/core/clientjs/protection_master_higherdose.js";
    setTimeout(function() {
      $.getScript(url, function() {
        getDrawerProductUpdate();
      });
    }, 500);
    // this.drawer.setAttribute('aria-hidden', false);
    // this.drawer.setAttribute('aria-expanded', true);
    // this.pageOverlayElement.classList.add('is-visible');
    // document.body.addEventListener('click', this.onBodyClick);
    setTimeout(function(){
      Rebuy.Cart.fetchCart(function(){
        Rebuy.init();
        Rebuy.SmartCart.show(event);
	  });
    }, 250)
    var x = this;
    document.addEventListener('rebuy.add', function(event){
		x.updateQuantity(1,1);
	});
  }
  
  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);
    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);
  }
  
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),event.target);
    var url = "https://www.guideprotection.com/protectit/core/clientjs/protection_master_higherdose.js";
    setTimeout(function() {
      $.getScript(url, function() {
        getDrawerProductUpdate();
        setTimeout(function(){ Rebuy.init(); }, 500)
      });
    }, 500);
  }
  
  updateQuantity(line, quantity, name,element,addItems = null) {
    this.enableLoading(line);
    let body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      }),
      actionUrl = routes.cart_change_url;

    if(addItems == null){
      if(quantity == 0 && element.closest('[data-have-installation]')){
        let itemKeys = element.closest('[data-have-installation]').dataset.haveInstallation.split(','),
            updateItems = {};
          updateItems.updates = {};
        itemKeys.forEach(ele => {
          updateItems.updates[ele] = 0;
        });
        updateItems.sections = this.getSectionsToRender().map((section) => section.section);
        updateItems.sections_url = window.location.pathname;
        body = JSON.stringify(updateItems);
        actionUrl = routes.cart_update_url;
      } 
    }else{
      actionUrl = routes.cart_add_url;
      body = JSON.stringify(addItems);
    }
    
    fetch(`${actionUrl}`, {
      ...fetchConfig(),
      ...{
        body
      }
    }).then((response) => {
      return response.text();
    }).then((state) => {
      const parsedState = JSON.parse(state);
      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
            
      this.disableLoading();
      Rebuy.init();
      
      // Extend - Dispatch refreshAjaxCart to initializeCartOffers on qtychange
      window.dispatchEvent(Extend.CustomEvent('refreshAjaxCart'))
      // Extend - End Code
      
    }).catch(() => {
      this.disableLoading();
    });
  }
  
  
  refreshCart() {
    this.enableLoading();
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
    .then((response) => {
      return response.text();
    }).then((state) => {
      const parsedState = JSON.parse(state);
      document.getElementById('cart-drawer__content').innerHTML =  this.getSectionInnerHTML(parsedState['cart-drawer'], '#cart-drawer__content');
      document.getElementById('cart-icon-bubble').innerHTML =  this.getSectionInnerHTML(parsedState['cart-icon-bubble'], '.shopify-section');
      
      this.disableLoading();
    }).catch(() => {
      this.disableLoading();
    });
  }
  
  getSectionsToRender() {
    return [{
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    }, {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading() {
    //document.getElementById('cart-drawer-loading').classList.remove('hidden');
  }

  disableLoading() {
    //document.getElementById('cart-drawer-loading').classList.add('hidden');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if ($(target).hasClass('page-overlay')) {
      this.close();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }
}

customElements.define('cart-drawer', CartDrawer);